import { i18nMark } from "@lingui/react";

import { FIELD_TYPES } from "base/constants";

export const FILTER_CATEGORIES = [
  i18nMark("Process"),
  i18nMark("Team"),
  i18nMark("Project"),
  i18nMark("Board"),
  i18nMark("Users")
];

export const FILTER_CATEGORIES_LABEL = {
  Process: i18nMark("Process"),
  Team: i18nMark("Teams"),
  Project: i18nMark("Project"),
  Case: i18nMark("Board"),
  Users: i18nMark("Users")
};

export const DATE_FILTER_LABELS = {
  All: i18nMark("All"),
  "Last 30 Days": i18nMark("Last 30 days"),
  "Last 90 Days": i18nMark("Last 90 days"),
  "Last 6 Months": i18nMark("Last 6 months"),
  "Last Year": i18nMark("Last year")
};

export const SEARCH_TYPE = {
  Posts: "post",
  Topics: "topic",
  People: "people",
  Items: "item"
};

export const SEARCH_FEATURE = {
  POST_ALLOW_FEATURE: "dwp_allow_channels_module"
};

export const DATE_RANGE = [
  "All",
  "Last 30 Days",
  "Last 90 Days",
  "Last 6 Months",
  "Last Year"
];

export const FLOW_ROLES = {
  Channel: {
    ADMIN: "Admin",
    MODERATOR: "Moderator",
    MEMBER: "Member",
    VIEW: "View",
    REQUESTACCESS: "RequestAccess"
  },
  Process: {
    SHARE: "Share",
    EDIT: "Edit",
    ADMIN: "Admin",
    INITIATE: "InitiateItems",
    REPORT: "CreateReport",
    VIEW: "Member",
    ASSIGNEE: "Assignee",
    PARTICIPATED: "Participated"
  },
  Project: {
    CREATE_ITEM: "CreateItem",
    ACCESS_PROJECT: "AccessProject",
    ADMIN: "Admin"
  },
  Case: {
    ADMIN: "Admin",
    CREATE_ITEM: "CreateItem",
    MANAGE_REPORT: "ManageReports",
    VIEW_REPORT: "ViewReports"
  },
  List: {
    SHARE: "Share",
    EDIT: "Edit",
    ADMIN: "Admin"
  },
  Dataset: {
    SHARE: "Share",
    EDIT: "Edit",
    ADMIN: "Admin",
    VIEW: "Member"
  },
  Report: {
    SHARE: "Share",
    ADMIN: "Admin",
    CREATEREPORT: "CreateReport"
  }
};

export const COMMON_FLOW_ROLES = {
  ADMIN: "Admin"
};

export const SEARCH_ROW_DATA = {
  Process: {
    Icon: "process",
    Heading: "flowName",
    Links: [
      {
        Label: i18nMark("New item"),
        OnClick: "onClickCreate",
        Roles: [FLOW_ROLES.Process.INITIATE, FLOW_ROLES.Process.ADMIN]
      },
      {
        Label: i18nMark("Assigned to me"),
        OnClick: "onClickPendingActions"
      },
      {
        Label: i18nMark("Reports"),
        OnClick: "onClickReports",
        Roles: [FLOW_ROLES.Process.REPORT, FLOW_ROLES.Process.ADMIN]
      }
    ]
  },
  Channel: {
    Icon: "channel",
    Heading: "flowName",
    Links: [
      {
        Label: i18nMark("Create post"),
        OnClick: "onClickCreatePost",
        Roles: [
          FLOW_ROLES.Channel.MEMBER,
          FLOW_ROLES.Channel.MODERATOR,
          FLOW_ROLES.Channel.ADMIN
        ]
      }
    ]
  },
  Dataset: {
    Icon: "dataset",
    Heading: "flowName"
  },
  List: {
    Icon: "list",
    Heading: "flowName"
  },
  Case: {
    Icon: "case",
    Heading: "flowName",
    Links: [
      {
        Label: i18nMark("New Item"),
        OnClick: "onClickCreate",
        Roles: [FLOW_ROLES.Case.CREATE_ITEM, FLOW_ROLES.Case.ADMIN]
      }
      // {
      //   Label: i18nMark("Reports"),
      //   OnClick: "onClickReports",
      //   Roles: [FLOW_ROLES.Case.ADMIN, FLOW_ROLES.Case.MANAGE_REPORT, FLOW_ROLES.Case.VIEW_REPORT]
      // }
    ]
  },
  Project: {
    Icon: "project",
    Heading: "flowName",
    Links: [
      {
        Label: i18nMark("New Item"),
        OnClick: "onClickCreate",
        Roles: [FLOW_ROLES.Project.CREATE_ITEM, FLOW_ROLES.Project.ADMIN]
      },
      {
        Label: i18nMark("Assigned to me"),
        OnClick: "onClickPendingActions",
        Roles: [FLOW_ROLES.Project.ACCESS_PROJECT, FLOW_ROLES.Project.ADMIN]
      }
      // {
      //   Label: i18nMark("Reports"),
      //   OnClick: "onClickReports",
      //   Roles: [FLOW_ROLES.Project.ACCESS_PROJECT, FLOW_ROLES.Project.ADMIN]
      // }
    ]
  },
  Team: {
    Icon: "team",
    Heading: "flowName"
  },
  Integration: {
    Icon: "integration",
    Heading: "flowName"
  }
};

export const PWA_SEARCH_ROW = {
  Process: {
    Icon: "process",
    Heading: "flowName",
    Links: [
      {
        Label: i18nMark("New item"),
        OnClick: "onClickCreate",
        Roles: [FLOW_ROLES.Process.INITIATE, FLOW_ROLES.Process.ADMIN]
      },
      {
        Label: i18nMark("Assigned to me"),
        OnClick: "onClickPendingActions"
      }
      // {
      //   Label: i18nMark("Reports"),
      //   OnClick: "onClickReports",
      //   Roles: [FLOW_ROLES.Process.REPORT, FLOW_ROLES.Process.ADMIN]
      // }
    ]
  },
  Case: {
    Icon: "case",
    Heading: "flowName",
    Links: [
      {
        Label: i18nMark("New Item"),
        OnClick: "onClickCreate",
        Roles: [FLOW_ROLES.Case.CREATE_ITEM, FLOW_ROLES.Case.ADMIN]
      }
      // {
      //   Label: i18nMark("Reports"),
      //   OnClick: "onClickReports",
      //   Roles: [FLOW_ROLES.Case.ADMIN, FLOW_ROLES.Case.MANAGE_REPORT, FLOW_ROLES.Case.VIEW_REPORT]
      // }
    ]
  },
  Application: {
    Icon: "application",
    Heading: "flowName"
  }
};

export const FLOW_STATUS = {
  ALL: "All",
  LIVE: "Live",
  DRAFT: "Draft",
  PENDING: "Pending",
  ARCHIVED: "Archived",
  DELETED: "Deleted"
};

export const DUEDATE_FILTER = {
  All: i18nMark("All"),
  Today: i18nMark("Today"),
  Tomorrow: i18nMark("Tomorrow"),
  ThisWeek: i18nMark("This week"),
  Crossed: i18nMark("Overdue")
};

export const CREATED_ON_FILTER = {
  All: i18nMark("All"),
  Today: i18nMark("Today"),
  Yesterday: i18nMark("Yesterday"),
  Last7Days: i18nMark("Last 7 Days"),
  Last14Days: i18nMark("Last 14 Days"),
  ThisMonth: i18nMark("This Month"),
  Last30Days: i18nMark("Last 30 Days"),
  CustomDateRange: i18nMark("Custom date range")
};

export const WORKFLOW_STATUS_FILTER = {
  AllWorkflows: {
    InProgress: {
      label: i18nMark("In progress"),
      key: "InProgress",
      description: "In progress(process), In progress(board)."
    },
    NotStarted: {
      label: i18nMark("Not started"),
      key: "NotStarted",
      description: "Draft(process), Not started(board), Reopened(board)."
    },
    Completed: {
      label: i18nMark("Completed"),
      key: "Completed",
      description:
        "Rejected(process), Withdrawn(process), Completed(process), Done(board), Closed(board)."
    }
  },
  Process: {
    NotStarted: { label: i18nMark("Not started"), key: "NotStarted" },
    InProgress: { label: i18nMark("In progress"), key: "InProgress" },
    Completed: { label: i18nMark("Completed"), key: "Completed" },
    Rejected: { label: i18nMark("Rejected"), key: "Rejected" },
    Withdrawn: { label: i18nMark("Withdrawn"), key: "Withdrawn" }
  },
  Case: {
    NotStarted: { label: i18nMark("Not started"), key: "NotStarted" },
    ReOpened: { label: i18nMark("Reopened"), key: "ReOpened" },
    InProgress: { label: i18nMark("In progress"), key: "InProgress" },
    Done: { label: i18nMark("Done"), key: "Done" },
    Closed: { label: i18nMark("Closed"), key: "Closed" }
  }
};

export const STATE_FILTER = {
  All: i18nMark("All"),
  Active: i18nMark("Active"),
  Hold: i18nMark("On hold"),
  Done: i18nMark("Done")
};

export const PLATFORM_FEATURES = {
  ALLOW_FAVOURITES: "platform_allow_favourites",
  ADMIN_ALLOW_ADMIN_TASKS: "admin_allow_admin_tasks"
};

export const PDF_SUPPORTED_FIELDS = [
  FIELD_TYPES.TEXT,
  FIELD_TYPES.TEXT_AREA,
  FIELD_TYPES.NUMBER,
  FIELD_TYPES.DATE,
  FIELD_TYPES.DATE_TIME,
  FIELD_TYPES.CURRENCY,
  FIELD_TYPES.EMAIL,
  FIELD_TYPES.SEQUENCE_NUMBER,
  FIELD_TYPES.SELECT,
  FIELD_TYPES.USER,
  FIELD_TYPES.MULTI_USER,
  FIELD_TYPES.BOOLEAN,
  FIELD_TYPES.SIGNATURE,
  FIELD_TYPES.IMAGE
];

export const ACTIVE_FLOW = {
  WORKFLOW: "workflow",
  PROJECT: "project",
  TEAM: "team"
};

export const FLOWS = {
  CASE: "Case",
  PROCESS: "Process",
  PROJECT: "Project",
  TEAM: "Team",
  DATASET: "Dataset",
  LIST: "List"
};

export const GLOBAL_MY_TASK_SYSTEM_FIELDS = {
  INITIATED_BY: i18nMark("Initiated by"),
  STEP_NAME: i18nMark("Step Name"),
  FLOW_TYPE: i18nMark("Flow Type"),
  ITEM_TITLE: i18nMark("Item Title"),
  DUE_DATE: i18nMark("Due Date"),
  FLOW_NAME: i18nMark("Flow Name"),
  CREATED_AT: i18nMark("Created at")
};

export const ZOOM_VALUES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3];
export const INITIAL_ZOOM = 3;

export const DIRECTION = {
  UP: "Up",
  DOWN: "Down",
  LEFT: "Left",
  RIGHT: "Right"
};

export const KEY_CODE = {
  PLUS: 187,
  MINUS: 189,
  KEY_R: 82,
  KEY_LEFT: 37,
  KEY_RIGHT: 39,
  KEY_UP: 38,
  KEY_DOWN: 40,
  KEY_F: 70,
  KEY_ESC: 27,
  KEY_TAB: "Tab",
  KEY_ENTER: "Enter",
  SPACE_BAR: 32,
  MUTE: 77,
  KEYDOWN: "keydown",
  ENTER: 13
};

export const UNSUPPORTED_MESSAGE = i18nMark(
  "This file cannot be previewed. Click Download to preview it offline."
);

export const PLAYBACK_SPEED = [
  { label: "0.5x", value: 0.5 },
  { label: i18nMark("Normal"), value: 1 },
  { label: "1.5x", value: 1.5 },
  { label: "2x", value: 2 }
];

export const DOM_SELECTOR = {
  MODAL_HEADER: "#modalHeader"
};

export const CLASSLIST = {
  SHOW_ELEMENT: "showElement",
  HIDE_ELEMENT: "hideElement"
};

export const CREATE_ITEM_PERMISSION = {
  process: ["Admin", "InitiateItems"],
  case: ["Admin", "CreateItem"]
};

export const EDIT_ITEM_PERMISSION = {
  process: ["Admin", "EditProcess"],
  case: ["Admin"]
};

export const UNARCHIVE_PERMISSION = ["Admin"];

export const SORT_BY_OBJECT = {
  _accessed_at: {
    key: "_accessed_at",
    sortBy: "_accessed_at",
    order: "asc",
    name: i18nMark("Recently opened")
  },
  Name: { key: "Name", sortBy: "Name", name: i18nMark("Name"), order: "asc" },
  Type: {
    key: "Type",
    sortBy: "Type",
    order: "asc",
    name: i18nMark("Type")
  },
  _created_at: {
    name: i18nMark("Recently created"),
    key: "_created_at",
    order: "des",
    sortBy: "_created_at"
  },
  _pulished_at: {
    name: i18nMark("Recently published"),
    key: "_pulished_at",
    order: "asc",
    sortBy: "LastPublishedAt"
  },
  _modified_at: {
    name: i18nMark("Recently modified"),
    key: "_modified_at",
    order: "des",
    sortBy: "_modified_at"
  }
};

export const STATUS_BY_OBJECT = {
  All: {
    type: "All",
    key: "All",
    name: i18nMark("All")
  },
  Live: {
    name: i18nMark("Live"),
    key: "Live",
    type: "Live"
  },
  Draft: {
    name: i18nMark("Draft"),
    key: "Draft",
    type: "Draft"
  },
  Pending: {
    name: i18nMark("Pending"),
    key: "Pending",
    type: "Pending"
  }
};

export const EXPLORER_TAB_ID = {
  ARCHIVED: "archived",
  OTHERS: "others",
  OWNED: "owned",
  ALL: "all"
};

export const MY_LIVE_FLOWS = [
  "InitiateItems",
  "Admin",
  "Assignee",
  "Participated",
  "EditReports",
  "CreateReports"
];

export const MANAGED_BY_ME = [
  "Admin",
  "EditProcess",
  "EditReports",
  "EditReports"
];

export const VIEW_TYPE = {
  listView: "listView",
  cardView: "cardView"
};

export const FLOW_NEW_ITEM_TOOLTIP = {
  Process: i18nMark("New item"),
  Case: i18nMark("New issue")
};

export const DEPARTMENT_ALL_OPTION = {
  All: { Id: "All", Name: i18nMark("All") },
  Process: { Id: "Process", Name: i18nMark("Process") },
  Dataset: { Id: "Dataset", Name: i18nMark("Dataset") },
  Case: {
    Id: "Case",
    Name: i18nMark("Board")
  },
  Application: { Id: "Application", Name: i18nMark("Application") },
  Portal: { Id: "Portal", Name: i18nMark("Portal") }
};

export const FILEPREVIEW_PLUGINS = {
  DOWNLOAD: "download",
  NEWTAB: "newtab",
  PIP: "pip",
  FULLSCREEN: "fullscreen",
  SPLITVIEW: "splitview"
};

export const FILEPREVIEW_PREVIOUS_VIEW = {
  DEFAULT: "default",
  PIP: "pip",
  SPLITVIEW: "split"
};

export const FLOW_FILTER = {
  Filter: {
    LHSField: "Type",
    RHSValue: "Process,Case,Dataset,Project,Application,Portal",
    Operator: "PART_OF"
  }
};

export const PWA_FLOW_FILTER = {
  Filter: {
    LHSField: "Type",
    RHSValue: "Process,Case,Application",
    Operator: "PART_OF"
  }
};

export const STYLES = {
  HIDDEN: "hidden",
  NONE: "none",
  BLOCK: "block",
  FLEX: "flex",
  VISIBLE: "visible"
};

export const SERVICE_ACCOUNT_HELP_DOCS = {
  SERVICE_ACCOUNT_IMPERSONATION_FLOW:
    // eslint-disable-next-line max-len
    "https://helpdocs.kissflow.com/service-accounts/impersonation-in-service-accounts#configuring_impersonation_access_to_flows"
};

export const EDITOR_FORMAT = {
  PDF: "pdf",
  MAIL: "mail"
};

export const CUSTOM_FIELD_TYPES = {
  LOGO: "Logo",
  LINK: "Link"
};
